export const financeSupporterAllSelector = (state) =>
  state?.financeSupporterReducer?.financeSupporterAll;
export const financeSupporterOpenAddSelector = (state) =>
  state?.financeSupporterReducer?.financeSupporterOpenAdd;
export const financeSupporterOpenEditSelector = (state) =>
  state?.financeSupporterReducer?.financeSupporterOpenEdit;
export const financeSupporterSelectedSelector = (state) =>
  state?.financeSupporterReducer?.financeSupporterSelected;
export const financeSupporterSearchSelector = (state) =>
  state?.financeSupporterReducer?.financeSupporterSearch;
export const financeSupporterDatesSelector = (state) =>
  state?.financeSupporterReducer?.financeSupporterDates;
